import { render, staticRenderFns } from "./otherContractCopy.vue?vue&type=template&id=4f9ec06c"
import script from "./otherContractCopy.vue?vue&type=script&lang=js"
export * from "./otherContractCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports